import { ImgHTMLAttributes } from "react";
import { PLACEHOLDER_URL } from "../../lib/lib";

type DishImageProps = Omit<ImgHTMLAttributes<HTMLImageElement>, "onError">;

export function DishImage({ src, ...props }: DishImageProps) {
  return (
    <img
      {...props}
      src={src || PLACEHOLDER_URL}
      onError={(event) => {
        const image = event.currentTarget;

        if (image.getAttribute("src") !== PLACEHOLDER_URL) {
          image.src = PLACEHOLDER_URL;
        }
      }}
    />
  );
}
